import { Button, SelectMultiple } from '~/components/ui'
import { valuesToValueLabelOptions } from '~/lib'
import type { ClientLabel } from '~/models'

type MapLabelsFilterProps = {
  clientLabels: ClientLabel[]
  labels: string[]
  updateFilter: (key: string, value: any) => void
}

export default function MapLabelsFilter({
  clientLabels,
  labels,
  updateFilter,
}: MapLabelsFilterProps) {
  const options = valuesToValueLabelOptions(
    clientLabels.map((label) => label.name)
  )

  return (
    <div className="space-y-2">
      <p className="text-sm">
        Labels
        {labels.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter('labels', [])}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultiple
        placeholder="Select labels..."
        options={options}
        selected={valuesToValueLabelOptions(labels)}
        setSelected={(selected) => {
          updateFilter(
            'labels',
            selected.map(({ value }) => value)
          )
        }}
      />
    </div>
  )
}
